// Centralized GraphQL document for shipping coarse interview debug logs (JS-only)
import { gql } from "@apollo/client";

export const SHIP_INTERVIEW_LOGS_GQL = gql`
  mutation ShipInterviewLogs($recordingId: String!, $sectionId: String, $callId: String, $entries: [InterviewLogEntryInput!]!) {
    shipInterviewLogs(recordingId: $recordingId, sectionId: $sectionId, callId: $callId, entries: $entries) {
      success
    }
  }
`;
